import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77e60004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "security" }
const _hoisted_2 = { class: "security_line_left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "line_left_content" }
const _hoisted_5 = { class: "left_content_title" }

import { ref } from 'vue';
import { mailbox, password, phone } from '@/assets';
import http from '@/api/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'Security',
  setup(__props) {

const securityList = ref([
  {
    id: 0,
    name: '账号密码',
    content: `当前密码强度：`,
    src: phone,
    text: '',
  },
  {
    id: 1,
    name: '密保手机',
    content: '已绑定手机：',
    src: password,
    text: '',
  },
  {
    id: 2,
    name: '备用邮箱',
    content: '已绑定邮箱：',
    src: mailbox,
    text: '',
  },
]);
const buildInfo = () => {
  http
    .buildInfo()
    .then((res) => {
      let data = res.data.data;
      securityList.value.map((res, index) => {
        res.text = index == 0 ? data.grade : index == 1 ? data.build_mobile : data.build_email;
      });
    })
    .catch((err) => console.error(err.data.error));
};
buildInfo();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(securityList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "security_line",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: item.src,
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("div", null, _toDisplayString(item.content) + " " + _toDisplayString(item.text), 1)
          ])
        ]),
        _createVNode(_component_router_link, {
          to: { path: '/modify', query: { id: item.id, text: item.text } },
          class: "security_line_modify"
        }, {
          default: _withCtx(() => [
            _createTextVNode("修改")
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}
}

})